<template>
  <ValidationProvider
    ref="validation"
    v-bind="getPropsForValidationProvider($props.field)"
    v-slot="{ errors, classes }"
    slim
  >
    <div :class="errors">
      <slot/>

      <div
        v-show="errors.length"
        class="text-danger mt-2"
      >
        {{ errors[0] }}
      </div>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {Field} from "@/Components/forms";

@Component
export default class ValidationWrapper extends Vue {

  @Prop({
    required: true
  })
  field!: Field;

  getPropsForValidationProvider(formField) {
    let rules = {};

    for (let i of formField.rules) {
      if (typeof i == 'string')
        rules[i] = true;
      else
        rules = Object.assign(rules, i);
    }

    return {
      name: formField.name,
      rules: rules
    };
  }
}
</script>
